import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";
import {TurnkeyCostData} from "../../types/tp-turnkey-cost-modal,types";
import {ProductCardFormFieldService} from "../../../../../services/product-card-form-field.service";
import {TpTurnkeyCostPathStateService} from "../../services/tp-turnkey-cost-path-state.service";
import {TpTurnkeyCostService} from "../../services/tp-turnkey-cost.service";
import {ModalsService} from "../../../../../../../../core/services/modals.service";
import {TurnkeyCostFilesStateService} from "../../services/turnkey-cost-files-state.service";

@Component({
  selector: 'app-turnkey-cost-accordion-header',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './turnkey-cost-accordion-header.component.html',
  styleUrl: './turnkey-cost-accordion-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TurnkeyCostAccordionHeaderComponent {
  turnkeyCost = input.required<TurnkeyCostData>();
  isEditModeActive = input<boolean>(false);
  handleDeleteTurnkeyCost = output<void>();

  private productCardFormFieldService: ProductCardFormFieldService = inject(ProductCardFormFieldService);
  private tpTurnkeyCostPathStateService: TpTurnkeyCostPathStateService = inject(TpTurnkeyCostPathStateService);
  private tpTurnkeyCostService: TpTurnkeyCostService = inject(TpTurnkeyCostService);
  private modalService: ModalsService = inject(ModalsService);
  private turnkeyCostFilesStateService: TurnkeyCostFilesStateService = inject(TurnkeyCostFilesStateService);

  public handleOpenHistory(event: MouseEvent): void {
    event.stopPropagation();
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.turnkeyCost().history,
      columnKey: 'turnkeyCostToMarketplaces'
    });
  }

  public async handleDelete(event: MouseEvent, id: number): Promise<void> {
    event.stopPropagation();
    const isConfirmed = await this.productCardFormFieldService.isDeleteConfirmed(id);
    if (!isConfirmed) { return; }

    await this.tpTurnkeyCostService.deleteData(this.tpTurnkeyCostPathStateService.pathState(), id)
      .then(() => this.successDelete(id));
  }

  private async successDelete(id: number): Promise<void> {
    this.turnkeyCostFilesStateService.deleteTurnkeyCostFilesState(id);
    this.handleDeleteTurnkeyCost.emit();
  }
}
